export const createUrl = (pathname: string, params: URLSearchParams) => {
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ''}`;
};
export const ensureStartsWith = (value: string, prefix: string) =>
  value.startsWith(prefix) ? value : `${prefix}${value}`;
